import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@vds/buttons';
import './footer.css';

const Container = styled.div`
    ${({ borderTop }) => borderTop && 'border-top: 1px solid #D8D8DA;'}
    background: ${({ surface }) => (surface === 'light' ? '#FFFFFF' : '#000000')};
    ${({ isFixed }) => isFixed && 'position: fixed ; bottom: 0; right: 0; left: 0;'}
    margin-top: 2rem;
`;
const ButtonContainer = styled.div`
    padding: 4rem 4.875rem;
    display: flex;
    gap: ${({ gap }) => (typeof gap === 'number' ? (`${gap}px`) : gap)};
    flex-direction: ${({ flexDirection }) => flexDirection};
    align-items: center;
    justify-content: center;
    button{border-radius: 800px; height: 7rem; font-size: 2rem; line-height: 2.25rem;}
`;

const Footer = (props) => {
  const {
    surface,
    borderTop,
    flexDirection,
    gap,
    buttonData,
    isFixed,
  } = props;

  return (
    <Container surface={surface} borderTop={borderTop} isFixed={isFixed}>
      <ButtonContainer flexDirection={flexDirection} gap={gap}>
        {buttonData?.map((button, index) => (
          <Button data-track={button.dataTrack} surface={surface} use={button?.use} key={`Footer_${index}`}  data-testid={button?.dataTestId} width={button?.width} size="large" disabled={button?.disabled || false} onClick={button?.onClick}>{button?.text}</Button>
        ))}
      </ButtonContainer>
    </Container>
  );
};

Footer.propTypes = {
  surface: PropTypes.string,
  borderTop: PropTypes.bool,
  flexDirection: PropTypes.string,
  gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  buttonData: PropTypes.array,
  isFixed: PropTypes.bool,
};
Footer.defaultProps = {
  surface: 'light',
  borderTop: true,
  flexDirection: 'row',
  gap: 16,
};

export default Footer;
